<template>
  <span>
    <el-dialog
      :title="title"
      :visible="visible"
      width="50%"
      @close="handleClose"
    >
      <el-row>
        <el-col :span="8">
          <div class="photo-item">
            <img v-if="validPhoto" :src="validPhoto" class="image">
          </div>
        </el-col>
        <el-col :span="16" style="border: 1px dashed #ebeef5; padding: 10px;">
          <div class="desc">拖拽图片可调整相册图片顺序，排序第一张的图片视为默认图</div>
          <el-row>
            <draggable :list="items">
              <el-col v-for="(photo, index) in items" :key="photo.url" :span="6" v-if="!photo.isDeleted">
                <OverlayOperator >
                  <div class="photo-item" :class="[index == 0 ? 'photo-default': '']">
                  <img v-bind:src="photo.url" class="image">
                </div>
                <div slot="operator">
                  <el-button type="text" style="font-size: 22px" @click="handleDelete(index)">
                    <i class="el-icon-delete"></i>
                  </el-button>
                </div>
                </OverlayOperator>
              </el-col>
            </draggable>
            <el-col :span="6">
              <div class="photo-item upload-item">
                <uploader
                  class="photo-uploader"
                  target="product-photo-upload"
                  @success="handleUploadSuccess"
                  @error="handleUploadError"
                  accept=".jpg,.jpeg,.png"
                >
                  <i class="el-icon-plus photo-uploader-icon"></i>
                </uploader>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
  import draggable from 'vuedraggable'
  import OverlayOperator from '@/components/OverlayOperator'

  export default {
    props: {
      photos: {
        type: Array,
        required: true
      },
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '默认标题'
      }
    },
    components: {
      draggable,
      OverlayOperator
    },
    computed: {
      validPhoto() {
        if(this.photos && this.photos.length > 0) {
          let photo = this.photos.find(item => !item.isDeleted)
          if(photo) {
            return photo.url
          }
          return ''
        } else{
          return ''
        }
      }
    },
    methods: {
      handleClose(done) {
        this.$emit('close')
      },
      handleSave() {
        this.$emit('save', this.items)
      },
      handleUploadSuccess(res, file) {
        this.addPhoto(res)
      },
      handleUploadError(error) {
        this.$message.error('上传失败了：' + error.message)
      },
      addPhoto({url = '', path = '', isLocal = true, isDeleted = false}){
        this.items.push({
          url,
          path,
          isLocal,
          isDeleted
        })
      },
      handleDelete(index){
        this.items.splice(index,1)
      }
    },

    data() {
      return {
        items: []
      }
    },
    mounted() {
      this.items = [...this.photos]
    }
  }
</script>

<style lang="less" scoped>
  .image {
    width: 100%;
    display: block;
  }
  .photo-item {
    margin: 10px;
  }
  .upload-item {

  }
  .photo-default {
    border: 1px solid #409EFF;
    position: relative;
  }
  .photo-default:before {
    position: absolute;
    content:"默认图";
    bottom: 0;
    right: 0;
    font-size: 12px;
    line-height: 12px;
    padding: 3px;
    color: #ffffff;
    background-color: #409EFF;
  }
  .desc {
    margin: 10px;
  }
  .photo-uploader /deep/.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
       border-color: #409EFF;
     }
  }
  .photo-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 99px;
    height: 99px;
    line-height: 99px;
    text-align: center;
  }
  .avatar {
    width: 99px;
    height: 99px;
    display: block;
  }
</style>
